import { SvgIcon, type SvgIconProps } from '@mui/material';
import React from 'react';

function BuildingIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 3H3V21H6V17H10V21H21V7H13V3ZM15 9H13V11H15V9ZM15 13H13V15H15V13ZM15 17H13V19H15V17ZM7 15H5V13H7V15ZM7 11H5V9H7V11ZM7 7H5V5H7V7ZM11 15H9V13H11V15ZM11 11H9V9H11V11ZM11 7H9V5H11V7ZM19 9H17V11H19V9ZM17 13H19V15H17V13ZM19 17H17V19H19V17Z"
      />
    </SvgIcon>
  );
}

export default BuildingIcon;
